"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _lodash = require("lodash");
var _formatID = _interopRequireDefault(require("../../utils/formatID"));
require("./SubNav.scss");
var _ellipses = _interopRequireDefault(require("../../images/ellipses.svg"));
var _close = _interopRequireDefault(require("../../images/close.svg"));
var _SiblingsMenu = _interopRequireDefault(require("./SiblingsMenu"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SubNav = _ref => {
  let {
    breadcrumbs = [],
    siblings = [],
    Link,
    isHidden
  } = _ref;
  const {
    mouse
  } = (0, _useMouse.default)();
  const [openBreadcrumbs, setOpenBreadcrumbs] = (0, _react.useState)(false);
  const [openSiblings, setOpenSiblings] = (0, _react.useState)(false);
  const handleCloseEvent = () => {
    setOpenSiblings(false);
    setOpenBreadcrumbs(false);
  };
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("click", handleCloseEvent);
      window.addEventListener("scroll", handleCloseEvent);
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("click", handleCloseEvent);
        window.removeEventListener("scroll", handleCloseEvent);
      }
    };
  }, []);
  const getWindowDimensions = () => {
    let height = 0;
    let width = 0;
    if (typeof window !== "undefined") {
      const {
        innerWidth,
        innerHeight
      } = window;
      width = innerWidth;
      height = innerHeight;
    }
    return {
      width,
      height
    };
  };
  const openBreadcrumbsWithEnter = event => {
    if (!mouse) {
      // checks that a user hits the enter key to open the breadcrumbs
      if (event.keyCode === 13) {
        setOpenBreadcrumbs(true);
        setOpenSiblings(false);
      }
    }
  };
  const closeBreadcrumbsWithEnter = event => {
    if (!mouse) {
      // checks that a user hits the enter key to close the breadcrumbs
      if (event.keyCode === 13) {
        setOpenSiblings(false);
        setOpenBreadcrumbs(false);
      }
    }
  };
  const openSiblingsWithEnter = event => {
    if (!mouse) {
      // checks that a user hits the enter key to open the Siblings
      if (event.keyCode === 13) {
        setOpenSiblings(true);
        setOpenBreadcrumbs(false);
      }
    }
  };
  const closeSiblingsWithEnter = event => {
    if (!mouse) {
      // checks that a user hits the enter key to close the Siblings
      if (event.keyCode === 13) {
        setOpenSiblings(false);
        setOpenBreadcrumbs(false);
      }
    }
  };
  const [windowDimensions, setWindowDimensions] = (0, _react.useState)(getWindowDimensions());
  (0, _react.useEffect)(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const {
    width
  } = windowDimensions;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-sub-nav ter-sub-nav__wrapper luna-layout__navigation-padding`,
    tabIndex: mouse ? "" : "0"
    // id={uniqueId("id-")}
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-sub-nav"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-sub-nav ter-sub-nav__breadcrumbs"
  }, breadcrumbs && breadcrumbs?.length <= 3 && width > 600 ? breadcrumbs?.map((breadcrumb, i) => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: `breadcrumb-${i}`
    }, breadcrumbs?.length === i + 1 ? /*#__PURE__*/_react.default.createElement(_SiblingsMenu.default, {
      title: breadcrumb.title,
      siblings: siblings,
      isOpen: openSiblings,
      width: width,
      closeSiblingsWithEnter: closeSiblingsWithEnter,
      Link: Link,
      onClose: () => {
        setOpenSiblings(false);
        setOpenBreadcrumbs(false);
      },
      onClick: e => {
        e.stopPropagation();
        setOpenSiblings(!openSiblings);
        setOpenBreadcrumbs(false);
      }
    }) : breadcrumb.slug ? /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      to: breadcrumb.slug,
      tabIndex: mouse ? "" : "0",
      key: `${breadcrumb.title}-${i}`,
      className: mouse ? "ter-sub-nav__breadcrumbs__link" : "ter-sub-nav__breadcrumbs__link tabFocus",
      target: "_self"
      // id={formatID(`${breadcrumb.title}-subnav-breadcumb`)}
      ,
      Link: Link
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: `ter-sub-nav__breadcrumbs__link__text ${i + 1 === breadcrumbs?.length && "ter-sub-nav__breadcrumbs__link__text--last"}`
    }, breadcrumb.title)) : /*#__PURE__*/_react.default.createElement("p", {
      key: `${breadcrumb.title}-${i}`,
      className: "ter-sub-nav__breadcrumbs__text"
    }, breadcrumb.title), i + 1 < breadcrumbs?.length && /*#__PURE__*/_react.default.createElement("span", {
      key: `divider-${i}`,
      style: {
        margin: "auto 0"
      }
    }, "\xA0/\xA0"));
  }) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      margin: "auto 0"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      position: "relative"
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    "aria-expanded": openBreadcrumbs,
    "aria-controls": "sub-nav-breadcrumbs",
    role: "button",
    onClick: e => {
      e.stopPropagation();
      setOpenBreadcrumbs(!openBreadcrumbs);
      setOpenSiblings(false);
    },
    onKeyDown: e => openBreadcrumbsWithEnter(e),
    src: _ellipses.default,
    tabIndex: "0",
    alt: "ellipses",
    className: "ter-sub-nav__breadcrumbs--ellipses-icon"
  })), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      margin: "auto 0"
    }
  }, "\xA0\xA0/\xA0\xA0"), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-sub-nav__breadcrumbs--current-page",
    style: {
      display: "flex"
    },
    tabIndex: mouse ? "" : "0",
    onClick: e => {
      e.stopPropagation();
      setOpenSiblings(!openSiblings);
      setOpenBreadcrumbs(false);
    },
    onKeyDown: e => openSiblingsWithEnter(e),
    "aria-expanded": openBreadcrumbs,
    "aria-controls": "sub-nav-siblings",
    role: "button"
    // id={formatID(
    //   `${
    //     breadcrumbs[breadcrumbs?.length - 1]?.title
    //   }-subnav-breadcumb`
    // )}
  }, /*#__PURE__*/_react.default.createElement(_SiblingsMenu.default, {
    title: breadcrumbs[breadcrumbs?.length - 1]?.title,
    siblings: siblings,
    isOpen: openSiblings,
    isHidden: isHidden,
    width: width,
    closeSiblingsWithEnter: closeSiblingsWithEnter,
    Link: Link,
    onClose: () => {
      setOpenSiblings(false);
      setOpenBreadcrumbs(false);
    },
    onClick: e => {
      e.stopPropagation();
      setOpenSiblings(!openSiblings);
      setOpenBreadcrumbs(false);
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    id: "sub-nav-breadcrumbs",
    className: `sub-nav-breadcrumbs`,
    style: {
      position: width > 600 ? "absolute" : "fixed",
      top: "auto",
      left: width < 600 && "0px",
      width: width > 600 ? "316px" : "100vw",
      display: openBreadcrumbs ? "flex" : "none"
    }
  }, width < 600 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-sub-nav__close-btn",
    style: {
      backgroundColor: "#0063A3",
      height: "44px",
      width: "44px",
      position: "absolute",
      right: "0",
      top: "0"
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    onClick: e => {
      e.stopPropagation();
      setOpenSiblings(false);
      setOpenBreadcrumbs(false);
    },
    onKeyDown: e => closeBreadcrumbsWithEnter(e),
    tabIndex: "0",
    src: _close.default,
    alt: "close",
    className: "ter-sub-nav__close-btn--icon",
    style: {
      height: "100%",
      width: "100%",
      padding: "15px",
      cursor: "pointer",
      margin: "auto",
      display: openBreadcrumbs ? "block" : "none"
    }
  })), breadcrumbs && breadcrumbs?.map((breadcrumb, i) => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: `breadcrumb-${i}`
    }, breadcrumb.slug && i + 1 < breadcrumbs.length ? /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      to: breadcrumb.slug,
      tabIndex: mouse ? "" : "0",
      key: breadcrumb.title,
      className: mouse ? "ter-sub-nav__breadcrumbs-collapse__link" : "ter-sub-nav__breadcrumbs-collapse__link tabFocus",
      target: "_self"
      // id={formatID(`${breadcrumb.title}-subnav-breadcumb`)}
      ,
      Link: Link,
      style: openBreadcrumbs ? {
        display: "block"
      } : {
        display: "none"
      }
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: `ter-sub-nav__breadcrumbs-collapse__link__text ${i + 1 === breadcrumbs?.length && "ter-sub-nav__breadcrumbs-collapse__link__text--last"}`
    }, breadcrumb.title)) : /*#__PURE__*/_react.default.createElement("p", {
      className: "ter-sub-nav__breadcrumbs__text "
    }, breadcrumb.title), i < breadcrumbs?.length - 1 && /*#__PURE__*/_react.default.createElement("span", {
      style: {
        margin: "auto 0"
      }
    }, "\xA0\xA0/\xA0\xA0"));
  })))));
};
var _default = SubNav;
exports.default = _default;